import { ReactElement } from "react";
import Person from "../components/icons/Person";
import { TeamMember } from "../team-member";
import { useTeam } from "./team-member-context";

export function MemberCard({ member, slot }: { member : TeamMember, slot?: ReactElement}) {
  return (
    <div
      key={member.id}
      className="p-4 bg-stone-300	 animate__animated animate__fadeIn flex flex-col max-w-40 items-center"
    >
      <Person />
      <p>{member.name}</p>
      { slot }
    </div>
    );
}

export function MemberCardWithDelete({ member }: { member : TeamMember}) {
  const { removeMember } = useTeam();
  const deleteMember = async (teamMember: TeamMember) => {
    removeMember(teamMember);
  }
  return (
    <MemberCard
      member={member}
      slot={
      <button data-testid={`delete-${member.id}`} onClick={() => deleteMember(member)}>Delete {member.name}</button>
    }/>
  );
}